// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"bed0c0c4","769":"1c9233c8"}[chunkId] + ".chunk.js";
};